import React from "react";
import withTheme from "../../../hocs/withTheme";
import "../Skeleton.css";

function SkeletonLine({
    width = "100%",
    height = 15,
    className = "",
    ...props
}) {
    return (
        <span
            className={`Skeleton line ${className}`}
            style={{ width, height }}
            {...props}
        />
    );
}


export default withTheme(SkeletonLine);
